import React from 'react';
import { Container, Paper, Typography, Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

// Shown to a signed-in account that an admin hasn't approved yet. Sign-up
// alone grants nothing: security rules and the Cloud Functions both check
// `approved` on the user doc, so this page is all a new account can reach.
// It updates on its own when the admin flips the flag (AuthContext listens
// to the user doc live).
export default function PendingApproval() {
  const { currentUser, logout } = useAuth();
  return (
    <Container maxWidth="sm" sx={{ mt: { xs: '80px', md: '128px' } }}>
      <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
          Waiting for approval
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Your account is created, but the pool admin hasn&apos;t added you yet.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Let them know you signed up as {currentUser?.email}. This page will update as soon as you&apos;re in.
        </Typography>
        <Button variant="outlined" onClick={logout}>Log out</Button>
      </Paper>
    </Container>
  );
}
